<!--收货地址选择器-->
<template>
    <el-select
            v-model="value"
            :multiple="isMultiple"
            filterable
            remote
            :disabled="isDisabled"
            reserve-keyword
            placeholder="请输入关键词"
            :remote-method="remoteMethod"
            :loading="loading"
            @change="handleChange"
            >
            <el-option
            v-for="item in list"
            :key="item.value"
            :label="item.label"
            :value="item.value">
            </el-option>
        </el-select>
</template>


<script>
import CommonService from "~/services/common";


export default {
    props: {
        express_id: '',
        disable: false, // 禁止选择
        order_id: {
            type: [Number, String],
            required: false,
            default: null,
        },
        isMultiple: {
            type: Boolean,
            required: false,
            default: false
        },
        enableOrderIdCheck: {
            type: Boolean,
            required: false,
            default: true // 默认启用订单ID检查
        },
        customer_id: {
            type: [Number, String],
            required: false,
            default: null
        },
    },
    data() {
        return {
            //定义变量
            loading: true,
            list: [],
            value: ''
        };
    },
    computed: {
        // 根据订单ID是否有内容来决定是否禁用
        isDisabled() {
            // 如果不启用订单ID检查，只检查 disable 属性
            if (!this.enableOrderIdCheck) {
                return this.disable;
            }
            // 启用订单ID检查时，检查订单ID是否有效
            return this.disable || !this.order_id || this.order_id === '' || this.order_id === 0;
        }
    },

    created: function() {
        this.value = this.express_id;
        /** 如果加载了这个组件，且订单ID有效，应当进行初始化操作 */
        if (!this.isDisabled) {
            this.remoteMethod();
        }
    },

    methods: {
        //远程搜索el-select远程获取方法。
        remoteMethod(query) {
            // 如果订单ID无效，不执行搜索
            if (this.isDisabled) {
                this.list = [];
                return;
            }
            
            if (query !== '') {
                this.loading = true;
                setTimeout(() => {
                    this.loading = false;
                    let params = {
                        order_id: this.order_id,
                        fields: 'id,name,mobile,label_name,address',
                        address: query,
                    };
                
                    // 如果order_id为0，传递customer_id；如果order_id不为0，不传customer_id
                    if (this.order_id == 0 && this.customer_id) {
                        params.customer_id = this.customer_id;
                    }
                    console.log(22222,params,this.customer_id);
                    CommonService.getOrderAddress(params).then(res => {
                        this.loading = false;
                        if (res.data) {
                            this.list = res.data.filter( item => {
                                if(!query) return true;
                                return item.address.toString().indexOf(query) > -1;
                            }).map(item => {
                                return {
                                    value: item.id,
                                    label: item.name + ' ' + item.mobile + ' ' + item.label_name + item.address
                                };
                            });
                        } else {
                            this.list = [];
                        }
                    });
                }, 200);
            } else {
                this.list = [];
            }
        },

        //select value值变化时触发
        handleChange(value) {
            this.$emit("change", value);
        },
        
        //对输入框进行重置
        reset(){
            this.list = [];
        }
    },
}

</script>


// WEBPACK FOOTER //
// src/widgets/OrderAddress.vue